var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeftnewqrsidersOptimized(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "katman_2",
    "data-name": "katman 2",
    viewBox: "0 0 17.29 46.83",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "katman_1",
    "data-name": "katman 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.08,25.72h17.15V0H.08v25.72ZM2.94,20h2.86v2.86h-2.86v-2.86ZM14.37,22.86h-5.72v-2.86h5.72v2.86ZM14.37,5.71h-2.86v5.72h2.86v2.86h-2.86v-2.86h-5.72v2.86h2.86v2.86H2.94v-5.72h2.86v-2.86h2.86v-2.86H2.94v-2.86h5.72v2.86h2.86v-2.86h2.86v2.86Z",
    fill: "#1e1e1c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5,38.37c.02-3.23-2.59-5.87-5.83-5.89-3.24-.02-5.87,2.59-5.89,5.82-.02,3.23,2.59,5.87,5.83,5.88,3.24.02,5.87-2.59,5.89-5.82",
    fill: "#010101"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.42,35.37c0-.42-.34-.77-.76-.77-.42,0-.77.34-.77.76,0,.42.34.77.76.77.43,0,.77-.34.77-.76",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.05,41.61s.4-2.15.6-2.15c.19,0,.56,2.16.56,2.16.05.25.17.44.43.44.31,0,.47-.21.44-.43v-.02s0-.01,0-.02l-.43-2.41-.08-.62c-.02-.1-.06-.39,0-.53.02-.04.05-.1.19-.15l1.31-.4h0c.22-.08.43-.2.43-.44,0-.24-.17-.51-.43-.44-.04,0-.07.02-.11.03-.36.1-1.49.4-2.29.39-.87,0-2.11-.36-2.36-.43-.01,0-.03,0-.04-.01h0s0,0,0,0c-.26-.07-.44.19-.44.43,0,.24.22.36.43.44,0,0,.01,0,.02,0l1.22.43c.16.06.23.12.24.15,0,0,0,0,0,0,.02.03.06.15,0,.5l-.08.62-.46,2.39s0,.04,0,.06c-.03.22.13.44.44.44.27,0,.39-.18.44-.43",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "16.79 35.76 16.79 30.35 11.5 30.35",
    fill: "none",
    stroke: "#1e1e1c",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "5.91 30.42 .5 30.42 .5 35.7",
    fill: "none",
    stroke: "#1e1e1c",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "11.37 46.26 16.79 46.26 16.79 40.98",
    fill: "none",
    stroke: "#1e1e1c",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("polyline", {
    points: ".57 40.91 .57 46.33 5.85 46.33",
    fill: "none",
    stroke: "#1e1e1c",
    strokeMiterlimit: 10
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftnewqrsidersOptimized);
export default __webpack_public_path__ + "static/media/leftnewqrsiders_optimized.c654b3bbd271689663f8d7fbe52c285e.svg";
export { ForwardRef as ReactComponent };